import { Module } from 'vuex';
import state, { IDataState } from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} as Module<IDataState, any>;
